<div class="tw-w-full tw-min-w-[296px]">
  <!-- min-w-[296px]: the room inside the filter card at the app's 344px minimum - 344 minus the
       16px gutters and the card's 8px padding (#6171). Mirrored by the skeleton in
       views.component.html. -->
  <div
    class="tw-flex tw-w-full tw-h-full tw-justify-between tw-items-center tw-p-2 tw-gap-4 xl:tw-flex-col tb:tw-gap-2 tb:tw-rounded-3xl xxs:tw-p-0"
  >
    <div class="tw-flex tw-w-full tw-h-full tw-gap-2 tw-items-center">
      <!--      granularity-->
      @if (currentView === ViewEnum.PAST || currentView === ViewEnum.FUTURE) {
        <app-dropdown-select
          class="tw-w-40 tw-shrink-0 sm:tw-w-20"
          [sort]="'date'"
          [options]="granularityMapOptions()"
          [selectedOption]="selectedGranularityMapValue()"
          [panelRadius]="'default'"
          [currentView]="currentView"
          [lockPageScroll]="true"
          (optionSelected)="pickGranularity($event)"
          [testLabel]="'granularity'"
        >
        </app-dropdown-select>
      } @else {
        <div
          class="tw-flex tw-justify-center tw-items-center tw-min-w-28 tw-w-fit tw-whitespace-nowrap tw-p-4 tw-rounded-2xl tw-bg-color-surface-hover tw-shadow-elevation-card"
        >
          <span>{{ todayRelativeLabel() }}</span>
        </div>
      }

      <!--    past view datepicker -->
      @if (currentView === ViewEnum.PAST) {
        <div class="tw-w-full tw-h-12">
          <app-past-views-datepicker></app-past-views-datepicker>
        </div>
      }

      <!--    today view datepicker -->
      @if (currentView === ViewEnum.TODAY) {
        <div class="tw-w-full tw-h-12">
          <app-today-views-datepicker></app-today-views-datepicker>
        </div>
      }

      <!--    future view datepicker -->
      @if (currentView === ViewEnum.FUTURE) {
        <div class="tw-w-full tw-h-12">
          <app-future-views-datepicker></app-future-views-datepicker>
        </div>
      }
    </div>

    <!--    filter-->
    <div class="tw-w-full tw-h-12">
      <app-views-customize></app-views-customize>
    </div>
  </div>
</div>
